module.exports = __webpack_public_path__ + "static/media/list.570325e4.svg";